import { Injectable } from '@angular/core';
import { Api } from './api';
import { tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PermissionService {
  
  private permisos: Record<string, string[]> = {};

  constructor(private api: Api) {}

  
  loadPermissions(usuario_id: string): Observable<any> {
    if (!usuario_id) return of(null);

    return this.api.getUserPermissions({ usuario_id }).pipe(
      tap((res: any) => {
        if (res.success) {
          this.permisos = res.permisos;
        }
      })
    );
  }

  
  setPermissions(permisos: Record<string, string[]>) {
    this.permisos = permisos;
  }

  hasPermission(modulo: string, accion: string): boolean {
    return this.permisos[modulo]?.includes(accion) || false;
  }

  getPermissions(): Record<string, string[]> {
    return this.permisos;
  }
}